export const WHATSAPP_FORMATED_NAME = 'WhatsApp';
export const FB_MESSENGER_FORMATED_NAME = 'FB Messenger';
export const SMS_FORMATED_NAME = 'SMS';
